module.exports = __webpack_public_path__ + "e1b6e7115abc8f86e0cf497b819b4763.svg";